import { useState } from 'react'
import { useRequestsHandlerData } from './useRequestsHandlerData'
import { cloneDeep } from 'lodash'
import Achievement from '../components/features/achiev/ui/main/Achievement'
import { useModal } from './useModal'
import useGetUserAchievementsWithMaxGrade from './shared/achievements/useGetUserAchievementsWithMaxGrade'
import { LIST } from '../components/modals/universalModal'
import { friendAchievementsContent } from '../constants/copyright-modals'

const { components, modalProps } = friendAchievementsContent

export const useExtraProfileIcons = () => {
  const { addModal } = useModal()
  const getUserAchievements = useGetUserAchievementsWithMaxGrade()
  const [isProcessing, setIsProcessing] = useState(false)

  const isPending = useRequestsHandlerData([
    {
      address: 'requestsDataIconsGetByUid',
      fulfilled({ icons }) {
        setIsProcessing(true)

        try {
          const filteredIcons = getUserAchievements(icons)

          addModal({
            type: 'universalModal',
            props: {
              modalProps,
              components: [
                {
                  list: [
                    ...cloneDeep(components),
                    {
                      type: LIST,
                      props: {
                        scrollbarModifier: ['width-mob-2-desk-3', `top-min-space`],
                        data: filteredIcons.map((icon) => ({
                          Component: Achievement,
                          props: { type: 'big-margin', ...icon },
                        })),
                      },
                    },
                  ],
                },
              ],
            },
          })
        } finally {
          setIsProcessing(false)
        }
      },
    },
  ])

  return isPending || isProcessing
}
